import { FC } from 'react';
import { cn } from '@new/lib';
import { Checkbox } from '@new/common/ui/Checkbox/Checkbox';
import {
  BULK_ACTION_BUTTON_CLASS,
  BULK_ACTION_ICON_CLASS,
  getBulkCourseActions,
} from '../../utils/bulkCourseActions';

interface BulkActionsBarProps {
  totalCount: number;
  selectedCount: number;
  isAllSelected: boolean;
  isIndeterminate: boolean;
  onSelectAll: () => void;
  onBulkDelete: () => void;
  onBulkStart: () => void;
  onBulkStop: () => void;
}

export const BulkActionsBar: FC<BulkActionsBarProps> = ({
  totalCount,
  selectedCount,
  isAllSelected,
  isIndeterminate,
  onSelectAll,
  onBulkDelete,
  onBulkStart,
  onBulkStop,
}) => {
  const hasSelection = selectedCount > 0;

  const title = hasSelection
    ? `${selectedCount} of ${totalCount} selected`
    : `Select all (${totalCount})`;

  const bulkActions = getBulkCourseActions({
    onBulkStart,
    onBulkStop,
    onBulkDelete,
  });

  return (
    <div className="flex items-center gap-4 px-4 py-2.5 rounded-lg transition-all border border-(--neutral-white-NW800) bg-(--neutral-white-NW900)">
      <div className="flex items-center gap-3">
        <div className="flex shrink-0 items-center scale-75 origin-left">
          <Checkbox
            variant="default"
            value={isAllSelected || isIndeterminate}
            onChange={onSelectAll}
          />
        </div>

        <span className="[font-family:var(--font-montserrat)] text-sm text-(--neutral-black-NB900) font-medium">
          {title}
        </span>
      </div>

      {hasSelection && (
        <div className="flex items-center gap-2 ml-auto">
          {bulkActions.map(({ title, icon: Icon, onClick, className }) => (
            <button
              key={title}
              type="button"
              onClick={onClick}
              title={title}
              className={cn(BULK_ACTION_BUTTON_CLASS, className)}
            >
              <Icon className={BULK_ACTION_ICON_CLASS} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
